import { z } from "zod";

export const slackConversationDeliverySchema = z
  .object({
    id: z.string().uuid(),
    connectionId: z.string().uuid(),
    status: z.enum(["queued", "sending", "sent", "uncertain", "failed"]),
    error: z.string().max(500).nullable(),
    updatedAt: z.string().datetime(),
  })
  .strict();
export const slackConversationDestinationSchema = z
  .object({
    id: z.string().uuid(),
    name: z.string(),
    channelName: z.string(),
    canSend: z.boolean(),
  })
  .strict();
export const slackConversationStatusResponseSchema = z
  .object({
    destinations: z.array(slackConversationDestinationSchema),
    deliveries: z.array(slackConversationDeliverySchema),
  })
  .strict();
export const sendSlackConversationRequestSchema = z
  .object({ connectionId: z.string().uuid() })
  .strict();
export const retrySlackConversationRequestSchema = z.object({}).strict();
export const slackConversationDeliveryResponseSchema = z
  .object({ delivery: slackConversationDeliverySchema })
  .strict();
const slackId = (prefix: string) =>
  z.string().regex(new RegExp(`^[${prefix}][A-Z0-9]{1,99}$`));
// Slack adds transport metadata. Only this validated subset can reach execution;
// response_url, tokens, message text and other provider fields are discarded.
export const slackConversationActionSchema = z.object({
  type: z.literal("block_actions"),
  team: z.object({ id: slackId("T") }),
  user: z.object({ id: slackId("UW") }),
  channel: z.object({ id: slackId("CG") }),
  container: z.object({ message_ts: z.string().regex(/^\d{1,20}\.\d{1,20}$/) }),
  actions: z
    .array(
      z.object({
        action_id: z.enum([
          "io_spoke_investigate:commitments",
          "io_spoke_investigate:customer_updates",
          "io_spoke_investigate:both",
          "io_spoke_investigate:cancel",
        ]),
        value: z.string().max(100),
      }),
    )
    .length(1),
});
export const slackConversationAnswerSchema = z
  .object({
    deliveryId: z.string().uuid(),
    answer: z.enum(["commitments", "customer_updates", "both", "cancel"]),
  })
  .strict();
export const slackConversationCommandSchema = z.object({
  command: z.literal("/iospoke"),
  team_id: slackId("T"),
  user_id: slackId("UW"),
  channel_id: slackId("CG"),
  text: z.string().trim().max(1000),
});
export type SlackConversationDelivery = z.infer<
  typeof slackConversationDeliverySchema
>;
export type SlackConversationStatus = z.infer<
  typeof slackConversationStatusResponseSchema
>;
export type SlackConversationAction = z.infer<
  typeof slackConversationActionSchema
>;
